module.exports = __webpack_public_path__ + "static/visualstudio-c3fddf08c9b061fe7e519008824f8037.png";